import SurveyDetailCard from "./surveyDetailCard.container";

export default SurveyDetailCard;
